(function () {
    "use strict";

    angular.module("sempraWebapp").factory("CreateUpdateCampaignViewModel", CreateUpdateCampaignViewModelFactory);

    /** @ngInject */
    function CreateUpdateCampaignViewModelFactory(
        $q,
        $translate,
        userGroupActions,
        localeFilters,
        campaignActions,
        CampaignTemplateEnum
    ) {
        function CreateUpdateCampaignViewModel(id) {
            this.id = id ? id : 0;
            this.dateFormat = localeFilters.defaultDateFormat;
            this.currentDate = new Date();
            this.from = new Date();
            this.to = new Date();
            this.title = "";
            this.isEditMode = this.id ? true : false;
            this.name = "";
            this.active = false;
            this.temporalRulePercentageValue;
            this.facilityTypes = [
                {
                    id: "WASH_BOXES",
                    name: $translate.instant("BRIDGE")
                },
                {
                    id: "SMALL_MACHINES",
                    name: $translate.instant("SMALL_MACHINES")
                }
            ];

            this.numberOfVisitsRule = null;
            this.amountOfMoneyRule = null;
            this.dailyTemporalRule = null;

            init.call(this);
        }

        CreateUpdateCampaignViewModel.prototype.destroy = function () { };

        CreateUpdateCampaignViewModel.prototype.onPeriodFromChanged = function () { };

        CreateUpdateCampaignViewModel.prototype.onPeriodToChanged = function () { };

        CreateUpdateCampaignViewModel.prototype.removeRule = function (ruleType) {
            switch (ruleType) {
                case CampaignTemplateEnum.NUM_OF_VISITS:
                    this.numberOfVisitsRule = null;
                    break;
                case CampaignTemplateEnum.MONEY_SPENT:
                    this.amountOfMoneyRule = null;
                    break;
                case CampaignTemplateEnum.DAILY_TEMPORAL:
                    this.dailyTemporalRule = null;
                    break;
            }
        };

        CreateUpdateCampaignViewModel.prototype.addNewByVisits = function () {
            this.numberOfVisitsRule = {
                id: 0,
                type: CampaignTemplateEnum.NUM_OF_VISITS,
                reward: {
                    code: "" //todo pull default code for company instead hardcode
                }
            };
        };

        CreateUpdateCampaignViewModel.prototype.addNewByMoneySpent = function () {
            this.amountOfMoneyRule = {
                id: 0,
                type: CampaignTemplateEnum.MONEY_SPENT,
                moneySpent: {
                    code: "" //todo pull default code for company instead hardcode
                },
                reward: {
                    code: "" //todo pull default code for company instead hardcode
                }
            };
        };

        CreateUpdateCampaignViewModel.prototype.addNewByDay = function () {
            this.dailyTemporalRule = {
                id: 0,
                days: [],
                daysOfWeek: getDaysOfWeekArray(),
                type: CampaignTemplateEnum.DAILY_TEMPORAL,
                reward: {
                    code: "" //todo pull default code for company instead hardcode
                }
            };
        };

        CreateUpdateCampaignViewModel.prototype.getDtoForPersistence = function () {
            var resultDto = {
                id: this.id,
                name: this.name,
                active: this.active,
                activeFrom: this.from.getTime(),
                activeTo: this.to.getTime(),
                // activeFrom: new DateTime(this.from).startOf(DateTime.units.DAY).timestamp,
                // activeTo: new DateTime(this.to).endOf(DateTime.units.DAY).timestamp,
                userGroupIds: this.groups
                    .filter(function (group) {
                        return group.selected && group.id !== -100;
                    })
                    .map(function (group) {
                        return group.id;
                    }),
                visitsRule: null,
                moneyRule: null,
                temporalRule: null
            };

            if (this.numberOfVisitsRule) {
                resultDto.visitsRule = {
                    id: this.numberOfVisitsRule.id,
                    visits: this.numberOfVisitsRule.visits,
                    reward: this.numberOfVisitsRule.reward,
                    validityPeriod: this.numberOfVisitsRule.validityPeriod
                };
            }

            if (this.amountOfMoneyRule) {
                resultDto.moneyRule = {
                    id: this.amountOfMoneyRule.id,
                    moneySpent: this.amountOfMoneyRule.moneySpent,
                    reward: this.amountOfMoneyRule.reward,
                    validityPeriod: this.amountOfMoneyRule.validityPeriod
                };
            }

            if (this.dailyTemporalRule) {
                this.checkToHourInterval(this.dailyTemporalRule);
                resultDto.temporalRule = {
                    id: this.dailyTemporalRule.id,
                    hoursFrom: this.dailyTemporalRule.hoursFrom,
                    minutesFrom: this.dailyTemporalRule.minutesFrom,
                    hoursTo: this.dailyTemporalRule.hoursTo,
                    minutesTo: this.dailyTemporalRule.minutesTo,
                    reward: this.dailyTemporalRule.reward,
                    deviceType: this.selectedFacilityType,
                    days: this.dailyTemporalRule.daysOfWeek
                        .filter(function (dayOfWeek) {
                            return dayOfWeek.selected;
                        })
                        .map(function (dayOfWeek) {
                            return dayOfWeek.value;
                        })
                };
            }

            return resultDto;
        };

      CreateUpdateCampaignViewModel.prototype.checkToHourInterval = function(rule) {
        if(rule.hoursTo === 0) {
          rule.minutesTo = 59;
          rule.hoursTo = 23;
        }
      };

        CreateUpdateCampaignViewModel.prototype.onSelectGroupChanged = function (group) {
            if (group.id === -100) {
                this.groups[0].selected = true;
                this.groups.forEach(function (group, index) {
                    if (index > 0) {
                        group.selected = false;
                    }
                });
            } else {
                var selectedGroups = this.groups.filter(function (group) {
                    return group.selected === true;
                });
                this.groups[0].selected = selectedGroups.length === 0;
            }
        };

        CreateUpdateCampaignViewModel.prototype.onSelectTemporalDeviceType = function (temporalDeviceType) {
            var that = this;
            userGroupActions.getTemporalRulePercentage(temporalDeviceType).then(function (res) {
                that.temporalRulePercentageValue = res;
            });
        };

        return CreateUpdateCampaignViewModel;

        function init() {
            var that = this;

            $q.all([userGroupActions.getUserGroups()]).then(function (resultArray) {
                var groupsJson = resultArray[0];

                refreshGroups.call(that, groupsJson);

                if (that.isEditMode) {
                    that.title = $translate.instant("BREAD_CRUMBS_EDIT_CAMPAIGN");
                    refreshForExisting.call(that);
                } else {
                    that.title = $translate.instant("BREAD_CRUMBS_NEW_CAMPAIGN");
                    that.groups[0].selected = true;
                    that.rules = [];
                    // that.addNewByDay();
                    // that.addNewByMoneySpent();
                    // that.addNewByVisits();
                }
            });
        }

        function refreshGroups(groupsJson) {
            var that = this;
            this.groups = [];
            this.groups.push({
                id: -100,
                name: $translate.instant("ALL_USERS"),
                selected: false
            });

            groupsJson.forEach(function (group) {
                group.selected = false;
                that.groups.push(group);
            });
        }

        function refreshForExisting() {
            var that = this;

            campaignActions.getCampaignById(this.id).then(function (campaignJson) {
                that.name = campaignJson.name;
                that.from = new Date(campaignJson.from);
                that.to = new Date(campaignJson.to);
                that.active = campaignJson.active;
                that.isEditMode = campaignJson.active; //new DateTime().timestamp < campaignJson.toTimestamp && new DateTime().timestamp > campaignJson.fromTimestamp;

                if (campaignJson.userGroupIds.length === 0) {
                    that.groups[0].selected = true;
                } else {
                    that.groups.forEach(function (group) {
                        group.selected = campaignJson.userGroupIds.indexOf(group.id) > -1;
                    });
                }

                that.numberOfVisitsRule = campaignJson.visitsRule ? campaignJson.visitsRule : null;
                if (that.numberOfVisitsRule) {
                    that.numberOfVisitsRule.type = CampaignTemplateEnum.NUM_OF_VISITS;
                }

                that.amountOfMoneyRule = campaignJson.moneyRule ? campaignJson.moneyRule : null;
                if (that.amountOfMoneyRule) {
                    that.amountOfMoneyRule.type = CampaignTemplateEnum.MONEY_SPENT;
                }

                that.dailyTemporalRule = campaignJson.temporalRule ? campaignJson.temporalRule : null;
                if (that.dailyTemporalRule) {
                    that.dailyTemporalRule.type = CampaignTemplateEnum.DAILY_TEMPORAL;
                    that.dailyTemporalRule.daysOfWeek = getDaysOfWeekArrayEditMode();
                    campaignJson.temporalRule.days.forEach(function (dayIndex) {
                        this[dayIndex].selected = true;
                    }, that.dailyTemporalRule.daysOfWeek);
                }
                if (campaignJson.temporalRule) {
                    that.selectedFacilityType = campaignJson.temporalRule.deviceType;
                    that.onSelectTemporalDeviceType(campaignJson.temporalRule.deviceType);
                }
            });
        }

        function getDaysOfWeekArray() {
            var daysOfWeek = [];
            for (var i = 0; i < 7; i++) {
                var j = i === 0 ? 6 : i - 1;
                daysOfWeek.push({
                    value: j,
                    name: localeFilters.getDayLocale(i, true),
                    selected: false
                });
            }
            return daysOfWeek;
        }

        function getDaysOfWeekArrayEditMode() {
            var daysOfWeek = [];
            for (var i = 0; i < 7; i++) {
                var j = i === 6 ? 0 : i + 1;
                daysOfWeek.push({
                    value: i,
                    name: localeFilters.getDayLocale(j, true),
                    selected: false
                });
            }
            return daysOfWeek;
        }

    }
})();
